module.exports = __webpack_public_path__ + "static/media/orbit.e0db21bb.png";